module.exports = __webpack_public_path__ + "static/scale-model-of-santa's-village-azoosment-park-in-elgin-illinois-bdda80696944fc748f8204d340a159b1.png";